import { ErrorBoundary } from '@shared/ui';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';

import './i18n';
import MainRouter from './Routers/MainRouter';
import { ToastProvider } from './context/ToastContext';

import './main.css';
import './styles/global.css';
import { muiTheme } from './styles/mui.theme';
import VerificationInputGlobalStyles from './styles/VerificationInputGlobalStyles';
import { queryClient } from './api/queryClient';

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <I18nextProvider i18n={i18next}>
        <ThemeProvider theme={muiTheme}>
          <CssBaseline />
          <VerificationInputGlobalStyles />
          <ToastProvider>
            <ErrorBoundary>
              <MainRouter />
            </ErrorBoundary>
          </ToastProvider>
        </ThemeProvider>
      </I18nextProvider>
    </QueryClientProvider>
  );
};

export default App;
